import React from 'react';
import './ClinicalEstablishmentLicensing.css'; // Create a CSS file for Clinical Establishment Licensing specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_clinical_banner from '../../assets/images/clinical-1.jpg'; // Replace with the actual image for clinical establishment licensing
import { FaHospital, FaFileAlt, FaShieldAlt, FaCertificate, FaClipboardList, FaHandsHelping } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function ClinicalEstablishmentLicensing() {
  const clinicalBenefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Enhanced Patient Safety',
      text: 'Ensure your clinical establishment follows safety protocols to protect patients.',
    },
    {
      icon: <FaCertificate />,
      title: 'Legal Compliance',
      text: 'Stay compliant with healthcare regulations and avoid legal penalties.',
    },
    {
      icon: <FaHospital />,
      title: 'Improved Reputation',
      text: 'Gain recognition and trust from patients and the medical community.',
    },
    {
      icon: <FaHandsHelping />,
      title: 'Quality Care',
      text: 'Ensure high-quality healthcare services through proper licensing.',
    },
  ];

  const steps = [
    {
      icon: <FaClipboardList />,
      title: 'Initial Consultation',
      description: 'Discuss the requirements for clinical establishment licensing.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Documentation Preparation',
      description: 'Prepare and gather all required documents for the licensing process.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Compliance Assessment',
      description: 'Perform an assessment to ensure your facility meets the required standards.',
    },
    {
      icon: <FaCertificate />,
      title: 'Application Submission',
      description: 'Submit the clinical establishment licensing application for approval.',
    },
    {
      icon: <FaHospital />,
      title: 'License Issuance',
      description: 'Receive your clinical establishment license and operate legally.',
    },
  ];

  const acts = [
    'Clinical Establishments (Registration and Regulation) Act',
    'Health and Safety Standards for Healthcare Facilities',
    'State Health Department Regulations',
  ];

  const explanation =
    'These laws ensure that clinical establishments adhere to health and safety standards to provide safe, reliable, and effective care to patients.';

  const checklistItems = [
    { name: 'Facility Registration', description: 'Submit the registration of the healthcare facility as per regulations.' },
    { name: 'Medical Equipment Details', description: 'Provide details of installed medical equipment and their compliance.' },
    { name: 'Health and Safety Audit', description: 'Include the latest health and safety audit report of the establishment.' },
    { name: 'Staff Qualifications', description: 'Attach details of healthcare staff qualifications and certifications.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Clinical Establishment Licensing & Compliance"
        subheading="Ensure your clinical establishment meets legal and safety standards with expert assistance."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/clinical-establishment-licensing' }}
        backgroundImage={img_clinical_banner} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Clinical Establishment Licensing?"
        description="Clinical establishment licensing is mandatory for ensuring that healthcare facilities operate in compliance with legal and safety standards. Our services help streamline the process of obtaining and maintaining clinical establishment licenses."
        image={img_clinical_banner} // Image for the clinical establishment licensing process
        altText="Clinical Establishment Licensing Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Clinical Establishment Licensing"
        description="Understand the advantages of obtaining a clinical establishment license for your healthcare facility."
        benefits={clinicalBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Healthcare and Compliance Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Clinical Establishment Licensing Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Clinical Establishment Licensing Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
